<div [class.mobile-open]="isOpen" class="sidebar app-sidebar" data-background-color="black" data-color="azure">
    <div class="logo app-logo">
        <a class="simple-text logo-normal">
        <span class="logo-plate">
          <img alt="SpeedTaxi logo" class="img-fluid imgSize" src="assets/images/logo-speed-taxi.svg">
        </span>
        </a>
    </div>
    <div (click)="handleNavigationClick($event)" class="sidebar-wrapper">
        <ul class="nav">
            <li class="nav-item" routerLinkActive="active">
                <a class="nav-link" routerLink="/central/overview">
                    <i class="material-icons">dashboard</i>
                    <p>{{ 'Overview' | translate }}</p>
                </a>
            </li>
            <li *ngIf="isAdminUser" class="nav-item" routerLinkActive="active">
                <a class="nav-link" routerLink="/central/cars">
                    <i class="material-icons">directions_car</i>
                    <p>{{ 'Cars' | translate }}</p>
                </a>
            </li>
            <li *ngIf="isAdminUser" class="nav-item" routerLinkActive="active">
                <a class="nav-link" routerLink="/central/map">
                    <i class="material-icons">map</i>
                    <p>{{ 'Map' | translate }}</p>
                </a>
            </li>
            <li *ngIf="isAdminUser" class="nav-item" routerLinkActive="active">
                <a class="nav-link" routerLink="/central/orders">
                    <i class="material-icons">list_alt</i>
                    <p>{{ 'Orders' | translate }}</p>
                </a>
            </li>
            <li *ngIf="isAdminUser" class="nav-item" routerLinkActive="active">
                <a class="nav-link" routerLink="/central/pos">
                    <i class="material-icons">point_of_sale</i>
                    <p>{{ 'POS Terminals' | translate }}</p>
                </a>
            </li>
            <li *ngIf="isAdminUser" class="nav-item" routerLinkActive="active">
                <a class="nav-link" routerLink="/central/vouchers">
                    <i class="material-icons">receipt</i>
                    <p>{{ 'Vouchers' | translate }}</p>
                </a>
            </li>
            <li *ngIf="isAdminUser" class="nav-item" routerLinkActive="active">
                <a class="nav-link" routerLink="/central/airportcars">
                    <i class="material-icons">local_airport</i>
                    <p>{{ 'Airport Cars' | translate }}</p>
                </a>
            </li>
            <li *ngIf="isAdminUser" class="nav-item" routerLinkActive="active">
                <a class="nav-link" routerLink="/central/airport-kiosk">
                    <i class="material-icons">desktop_windows</i>
                    <p>{{ 'Airport Kiosk' | translate }}</p>
                </a>
            </li>
        </ul>
    </div>
</div>
